import type { ReactNode } from "react";

import CustomCursor from "@/components/CustomCursor";

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-[#fff5ec] text-[#003f28] [&:has(.access-page)]:h-dvh [&:has(.access-page)]:max-h-dvh [&:has(.access-page)]:min-h-0 [&:has(.access-page)]:overflow-hidden">
      <CustomCursor />
      {children}
    </div>
  );
}
